// @ts-nocheck
import { useMutation, useQuery } from "@tanstack/vue-query";
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";

import { unref } from "vue";

import type {
  ActivateAccountInputModel,
  ChangePasswordInputModel,
  InitPasswordResetInputModel,
  Login200,
  LoginBody,
  ResetPasswordInputModel,
} from "../models";

import { authCustomInstance } from "../../../src/auth-custom-axios";
import type { ErrorType, BodyType } from "../../../src/auth-custom-axios";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type postActivateGlobalUserResponseDefault = {
  data: void;
  status: number;
};
export type postActivateGlobalUserResponseError = postActivateGlobalUserResponseDefault & {
  headers: Headers;
};

export type postActivateGlobalUserResponse = postActivateGlobalUserResponseError;

export const getPostActivateGlobalUserUrl = (token: string) => {
  return `/api/auth/userActivations/${token}`;
};

export const postActivateGlobalUser = async (
  token: string,
  activateAccountInputModel: ActivateAccountInputModel,
  options?: RequestInit,
): Promise<postActivateGlobalUserResponse> => {
  return authCustomInstance<postActivateGlobalUserResponse>(getPostActivateGlobalUserUrl(token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(activateAccountInputModel),
  });
};

export const getPostActivateGlobalUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivateGlobalUser>>,
    TError,
    { token: string; data: BodyType<ActivateAccountInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivateGlobalUser>>,
  TError,
  { token: string; data: BodyType<ActivateAccountInputModel> },
  TContext
> => {
  const mutationKey = ["postActivateGlobalUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivateGlobalUser>>,
    { token: string; data: BodyType<ActivateAccountInputModel> }
  > = (props) => {
    const { token, data } = props ?? {};

    return postActivateGlobalUser(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivateGlobalUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActivateGlobalUser>>
>;
export type PostActivateGlobalUserMutationBody = BodyType<ActivateAccountInputModel>;
export type PostActivateGlobalUserMutationError = ErrorType<void>;

export const usePostActivateGlobalUser = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postActivateGlobalUser>>,
      TError,
      { token: string; data: BodyType<ActivateAccountInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postActivateGlobalUser>>,
  TError,
  { token: string; data: BodyType<ActivateAccountInputModel> },
  TContext
> => {
  const mutationOptions = getPostActivateGlobalUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type postActivateGlobalUser1ResponseDefault = {
  data: void;
  status: number;
};
export type postActivateGlobalUser1ResponseError = postActivateGlobalUser1ResponseDefault & {
  headers: Headers;
};

export type postActivateGlobalUser1Response = postActivateGlobalUser1ResponseError;

export const getPostActivateGlobalUser1Url = (token: string) => {
  return `/api/auth/userActivations/${token}`;
};

export const postActivateGlobalUser1 = async (
  token: string,
  activateAccountInputModel: ActivateAccountInputModel,
  options?: RequestInit,
): Promise<postActivateGlobalUser1Response> => {
  return authCustomInstance<postActivateGlobalUser1Response>(getPostActivateGlobalUser1Url(token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(activateAccountInputModel),
  });
};

export const getPostActivateGlobalUser1MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivateGlobalUser1>>,
    TError,
    { token: string; data: BodyType<ActivateAccountInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivateGlobalUser1>>,
  TError,
  { token: string; data: BodyType<ActivateAccountInputModel> },
  TContext
> => {
  const mutationKey = ["postActivateGlobalUser1"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivateGlobalUser1>>,
    { token: string; data: BodyType<ActivateAccountInputModel> }
  > = (props) => {
    const { token, data } = props ?? {};

    return postActivateGlobalUser1(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivateGlobalUser1MutationResult = NonNullable<
  Awaited<ReturnType<typeof postActivateGlobalUser1>>
>;
export type PostActivateGlobalUser1MutationBody = BodyType<ActivateAccountInputModel>;
export type PostActivateGlobalUser1MutationError = ErrorType<void>;

export const usePostActivateGlobalUser1 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postActivateGlobalUser1>>,
      TError,
      { token: string; data: BodyType<ActivateAccountInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postActivateGlobalUser1>>,
  TError,
  { token: string; data: BodyType<ActivateAccountInputModel> },
  TContext
> => {
  const mutationOptions = getPostActivateGlobalUser1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type patchChangePasswordResponseDefault = {
  data: void;
  status: number;
};
export type patchChangePasswordResponseError = patchChangePasswordResponseDefault & {
  headers: Headers;
};

export type patchChangePasswordResponse = patchChangePasswordResponseError;

export const getPatchChangePasswordUrl = () => {
  return `/api/auth/userPasswords`;
};

export const patchChangePassword = async (
  changePasswordInputModel: ChangePasswordInputModel,
  options?: RequestInit,
): Promise<patchChangePasswordResponse> => {
  return authCustomInstance<patchChangePasswordResponse>(getPatchChangePasswordUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordInputModel),
  });
};

export const getPatchChangePasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchChangePassword>>,
    TError,
    { data: BodyType<ChangePasswordInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordInputModel> },
  TContext
> => {
  const mutationKey = ["patchChangePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchChangePassword>>,
    { data: BodyType<ChangePasswordInputModel> }
  > = (props) => {
    const { data } = props ?? {};

    return patchChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchChangePassword>>
>;
export type PatchChangePasswordMutationBody = BodyType<ChangePasswordInputModel>;
export type PatchChangePasswordMutationError = ErrorType<void>;

export const usePatchChangePassword = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchChangePassword>>,
      TError,
      { data: BodyType<ChangePasswordInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordInputModel> },
  TContext
> => {
  const mutationOptions = getPatchChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type patchChangePassword1ResponseDefault = {
  data: void;
  status: number;
};
export type patchChangePassword1ResponseError = patchChangePassword1ResponseDefault & {
  headers: Headers;
};

export type patchChangePassword1Response = patchChangePassword1ResponseError;

export const getPatchChangePassword1Url = () => {
  return `/api/auth/userPasswords`;
};

export const patchChangePassword1 = async (
  changePasswordInputModel: ChangePasswordInputModel,
  options?: RequestInit,
): Promise<patchChangePassword1Response> => {
  return authCustomInstance<patchChangePassword1Response>(getPatchChangePassword1Url(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordInputModel),
  });
};

export const getPatchChangePassword1MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchChangePassword1>>,
    TError,
    { data: BodyType<ChangePasswordInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchChangePassword1>>,
  TError,
  { data: BodyType<ChangePasswordInputModel> },
  TContext
> => {
  const mutationKey = ["patchChangePassword1"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchChangePassword1>>,
    { data: BodyType<ChangePasswordInputModel> }
  > = (props) => {
    const { data } = props ?? {};

    return patchChangePassword1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchChangePassword1MutationResult = NonNullable<
  Awaited<ReturnType<typeof patchChangePassword1>>
>;
export type PatchChangePassword1MutationBody = BodyType<ChangePasswordInputModel>;
export type PatchChangePassword1MutationError = ErrorType<void>;

export const usePatchChangePassword1 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchChangePassword1>>,
      TError,
      { data: BodyType<ChangePasswordInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchChangePassword1>>,
  TError,
  { data: BodyType<ChangePasswordInputModel> },
  TContext
> => {
  const mutationOptions = getPatchChangePassword1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type getApiAuthCurrentGlobalUserResponseDefault = {
  data: void;
  status: number;
};
export type getApiAuthCurrentGlobalUserResponseError =
  getApiAuthCurrentGlobalUserResponseDefault & {
    headers: Headers;
  };

export type getApiAuthCurrentGlobalUserResponse = getApiAuthCurrentGlobalUserResponseError;

export const getGetApiAuthCurrentGlobalUserUrl = () => {
  return `/api/auth/currentGlobalUser`;
};

export const getApiAuthCurrentGlobalUser = async (
  options?: RequestInit,
): Promise<getApiAuthCurrentGlobalUserResponse> => {
  return authCustomInstance<getApiAuthCurrentGlobalUserResponse>(
    getGetApiAuthCurrentGlobalUserUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetApiAuthCurrentGlobalUserQueryKey = () => {
  return ["api", "auth", "currentGlobalUser"] as const;
};

export const getGetApiAuthCurrentGlobalUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiAuthCurrentGlobalUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>> = ({
    signal,
  }) => getApiAuthCurrentGlobalUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>,
    TError,
    TData
  >;
};

export type GetApiAuthCurrentGlobalUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>
>;
export type GetApiAuthCurrentGlobalUserQueryError = ErrorType<void>;

export function useGetApiAuthCurrentGlobalUser<
  TData = Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthCurrentGlobalUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export type getApiAuthCurrentGlobalUser1ResponseDefault = {
  data: void;
  status: number;
};
export type getApiAuthCurrentGlobalUser1ResponseError =
  getApiAuthCurrentGlobalUser1ResponseDefault & {
    headers: Headers;
  };

export type getApiAuthCurrentGlobalUser1Response = getApiAuthCurrentGlobalUser1ResponseError;

export const getGetApiAuthCurrentGlobalUser1Url = () => {
  return `/api/auth/currentGlobalUser`;
};

export const getApiAuthCurrentGlobalUser1 = async (
  options?: RequestInit,
): Promise<getApiAuthCurrentGlobalUser1Response> => {
  return authCustomInstance<getApiAuthCurrentGlobalUser1Response>(
    getGetApiAuthCurrentGlobalUser1Url(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetApiAuthCurrentGlobalUser1QueryKey = () => {
  return ["api", "auth", "currentGlobalUser"] as const;
};

export const getGetApiAuthCurrentGlobalUser1QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>, TError, TData>
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiAuthCurrentGlobalUser1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>> = ({
    signal,
  }) => getApiAuthCurrentGlobalUser1({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>,
    TError,
    TData
  >;
};

export type GetApiAuthCurrentGlobalUser1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>
>;
export type GetApiAuthCurrentGlobalUser1QueryError = ErrorType<void>;

export function useGetApiAuthCurrentGlobalUser1<
  TData = Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCurrentGlobalUser1>>, TError, TData>
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthCurrentGlobalUser1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export type loginResponse200 = {
  data: Login200;
  status: 200;
};

export type loginResponseSuccess = loginResponse200 & {
  headers: Headers;
};
export type loginResponse = loginResponseSuccess;

export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<loginResponse> => {
  return authCustomInstance<loginResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<unknown>;

export const useLogin = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      { data: BodyType<LoginBody> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationOptions = getLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type postApiAuthPasswordResetResponseDefault = {
  data: void;
  status: number;
};
export type postApiAuthPasswordResetResponseError = postApiAuthPasswordResetResponseDefault & {
  headers: Headers;
};

export type postApiAuthPasswordResetResponse = postApiAuthPasswordResetResponseError;

export const getPostApiAuthPasswordResetUrl = () => {
  return `/api/auth/passwordResets`;
};

export const postApiAuthPasswordReset = async (
  initPasswordResetInputModel: InitPasswordResetInputModel,
  options?: RequestInit,
): Promise<postApiAuthPasswordResetResponse> => {
  return authCustomInstance<postApiAuthPasswordResetResponse>(getPostApiAuthPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(initPasswordResetInputModel),
  });
};

export const getPostApiAuthPasswordResetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthPasswordReset>>,
    TError,
    { data: BodyType<InitPasswordResetInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthPasswordReset>>,
  TError,
  { data: BodyType<InitPasswordResetInputModel> },
  TContext
> => {
  const mutationKey = ["postApiAuthPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAuthPasswordReset>>,
    { data: BodyType<InitPasswordResetInputModel> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAuthPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAuthPasswordReset>>
>;
export type PostApiAuthPasswordResetMutationBody = BodyType<InitPasswordResetInputModel>;
export type PostApiAuthPasswordResetMutationError = ErrorType<void>;

export const usePostApiAuthPasswordReset = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuthPasswordReset>>,
      TError,
      { data: BodyType<InitPasswordResetInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiAuthPasswordReset>>,
  TError,
  { data: BodyType<InitPasswordResetInputModel> },
  TContext
> => {
  const mutationOptions = getPostApiAuthPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type postApiAuthPasswordReset1ResponseDefault = {
  data: void;
  status: number;
};
export type postApiAuthPasswordReset1ResponseError = postApiAuthPasswordReset1ResponseDefault & {
  headers: Headers;
};

export type postApiAuthPasswordReset1Response = postApiAuthPasswordReset1ResponseError;

export const getPostApiAuthPasswordReset1Url = () => {
  return `/api/auth/passwordResets`;
};

export const postApiAuthPasswordReset1 = async (
  initPasswordResetInputModel: InitPasswordResetInputModel,
  options?: RequestInit,
): Promise<postApiAuthPasswordReset1Response> => {
  return authCustomInstance<postApiAuthPasswordReset1Response>(getPostApiAuthPasswordReset1Url(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(initPasswordResetInputModel),
  });
};

export const getPostApiAuthPasswordReset1MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthPasswordReset1>>,
    TError,
    { data: BodyType<InitPasswordResetInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthPasswordReset1>>,
  TError,
  { data: BodyType<InitPasswordResetInputModel> },
  TContext
> => {
  const mutationKey = ["postApiAuthPasswordReset1"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAuthPasswordReset1>>,
    { data: BodyType<InitPasswordResetInputModel> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAuthPasswordReset1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthPasswordReset1MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAuthPasswordReset1>>
>;
export type PostApiAuthPasswordReset1MutationBody = BodyType<InitPasswordResetInputModel>;
export type PostApiAuthPasswordReset1MutationError = ErrorType<void>;

export const usePostApiAuthPasswordReset1 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuthPasswordReset1>>,
      TError,
      { data: BodyType<InitPasswordResetInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiAuthPasswordReset1>>,
  TError,
  { data: BodyType<InitPasswordResetInputModel> },
  TContext
> => {
  const mutationOptions = getPostApiAuthPasswordReset1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type postPasswordResetResponseDefault = {
  data: void;
  status: number;
};
export type postPasswordResetResponseError = postPasswordResetResponseDefault & {
  headers: Headers;
};

export type postPasswordResetResponse = postPasswordResetResponseError;

export const getPostPasswordResetUrl = (token: string) => {
  return `/api/auth/passwordResets/${token}`;
};

export const postPasswordReset = async (
  token: string,
  resetPasswordInputModel: ResetPasswordInputModel,
  options?: RequestInit,
): Promise<postPasswordResetResponse> => {
  return authCustomInstance<postPasswordResetResponse>(getPostPasswordResetUrl(token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resetPasswordInputModel),
  });
};

export const getPostPasswordResetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPasswordReset>>,
    TError,
    { token: string; data: BodyType<ResetPasswordInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPasswordReset>>,
  TError,
  { token: string; data: BodyType<ResetPasswordInputModel> },
  TContext
> => {
  const mutationKey = ["postPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPasswordReset>>,
    { token: string; data: BodyType<ResetPasswordInputModel> }
  > = (props) => {
    const { token, data } = props ?? {};

    return postPasswordReset(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPasswordReset>>
>;
export type PostPasswordResetMutationBody = BodyType<ResetPasswordInputModel>;
export type PostPasswordResetMutationError = ErrorType<void>;

export const usePostPasswordReset = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPasswordReset>>,
      TError,
      { token: string; data: BodyType<ResetPasswordInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postPasswordReset>>,
  TError,
  { token: string; data: BodyType<ResetPasswordInputModel> },
  TContext
> => {
  const mutationOptions = getPostPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export type postPasswordReset1ResponseDefault = {
  data: void;
  status: number;
};
export type postPasswordReset1ResponseError = postPasswordReset1ResponseDefault & {
  headers: Headers;
};

export type postPasswordReset1Response = postPasswordReset1ResponseError;

export const getPostPasswordReset1Url = (token: string) => {
  return `/api/auth/passwordResets/${token}`;
};

export const postPasswordReset1 = async (
  token: string,
  resetPasswordInputModel: ResetPasswordInputModel,
  options?: RequestInit,
): Promise<postPasswordReset1Response> => {
  return authCustomInstance<postPasswordReset1Response>(getPostPasswordReset1Url(token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resetPasswordInputModel),
  });
};

export const getPostPasswordReset1MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPasswordReset1>>,
    TError,
    { token: string; data: BodyType<ResetPasswordInputModel> },
    TContext
  >;
  request?: SecondParameter<typeof authCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPasswordReset1>>,
  TError,
  { token: string; data: BodyType<ResetPasswordInputModel> },
  TContext
> => {
  const mutationKey = ["postPasswordReset1"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPasswordReset1>>,
    { token: string; data: BodyType<ResetPasswordInputModel> }
  > = (props) => {
    const { token, data } = props ?? {};

    return postPasswordReset1(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPasswordReset1MutationResult = NonNullable<
  Awaited<ReturnType<typeof postPasswordReset1>>
>;
export type PostPasswordReset1MutationBody = BodyType<ResetPasswordInputModel>;
export type PostPasswordReset1MutationError = ErrorType<void>;

export const usePostPasswordReset1 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPasswordReset1>>,
      TError,
      { token: string; data: BodyType<ResetPasswordInputModel> },
      TContext
    >;
    request?: SecondParameter<typeof authCustomInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postPasswordReset1>>,
  TError,
  { token: string; data: BodyType<ResetPasswordInputModel> },
  TContext
> => {
  const mutationOptions = getPostPasswordReset1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
